export default __webpack_public_path__ + "static/media/slide1.ba4381be.jpg";